var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar',{staticClass:"navbar shadow-sm",attrs:{"sticky":""}},[_c('p',{staticClass:"m-0 text-center flex-fill"},[_vm._v(" "+_vm._s(_vm.$t('此為預覽畫面'))+" - "+_vm._s(_vm.eventStatusLabel)+" ")]),_c('b-button',{staticClass:"btn-go-backstage",attrs:{"variant":"primary"},on:{"click":_vm.goBackstage}},[_vm._v(" "+_vm._s(_vm.$t('返回後台頁面'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }